// actions.js
import axios from 'axios';

// Action types
export const SET_DATA_NEWTARIFF = 'SET_DATA_NEWTARIFF';
export const SET_DATA_ELECTRICITY_CHARGES = 'SET_DATA_ELECTRICITY_CHARGES';
export const SET_DATA_OTHER_CHARGES = 'SET_DATA_OTHER_CHARGES';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const UPLOAD_DATA_NEWTARIFF = 'UPLOAD_DATA_NEWTARIFF';
// Action creators

export const setDataNewTariff = (data) => ({
  type: SET_DATA_NEWTARIFF,
  payload: data
});

export const setDataElectricityCharges = (data) => ({
  type: SET_DATA_ELECTRICITY_CHARGES,
  payload: data
});

export const setDataOtherCharges = (data) => ({
  type: SET_DATA_OTHER_CHARGES,
  payload: data
});

export const fetchDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data
});

export const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error
});


export const uploadDataNewTariff = (data) => ({
  type: UPLOAD_DATA_NEWTARIFF,
  payload: data
});